var map = {
	"./Msg": [
		96252,
		7713
	],
	"./Msg/": [
		96252,
		7713
	],
	"./Msg/index": [
		96252,
		7713
	],
	"./Msg/index.js": [
		96252,
		7713
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 45215;
module.exports = webpackAsyncContext;